module.exports = __webpack_public_path__ + "media/images/question-7beb6156629a558bc913c439b162057c.png";